export * from './new-edit-mercado-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/mercado/new-edit-mercado-dialog/index.ts